import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { useForm } from "@inertiajs/react";
import { Loader2 } from "lucide-react";

type Props = {
  detection: {
    enabled: boolean;
    keywords: string | null;
  };
};

export function SoldMessageDetectionSection({ detection }: Props) {
  const form = useForm({
    section: "sold_message_detection",
    sold_message_detection_enabled: detection.enabled,
    sold_message_detection_keywords: detection.keywords ?? "",
  });

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    form.put("/app/settings");
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Detecção de vendas</CardTitle>
        <CardDescription>
          Detecte vendas automaticamente a partir de mensagens enviadas no
          WhatsApp que contenham palavras-chave configuradas.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor="detection-toggle">Ativar detecção</Label>
              <p className="text-muted-foreground text-sm">
                Quando ativado, mensagens enviadas serão analisadas
                automaticamente.
              </p>
            </div>
            <Switch
              id="detection-toggle"
              checked={form.data.sold_message_detection_enabled}
              onCheckedChange={(checked) =>
                form.setData("sold_message_detection_enabled", checked)
              }
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="detection-keywords">Palavras-chave</Label>
            <Textarea
              id="detection-keywords"
              placeholder="Uma palavra-chave por linha, ex:&#10;vendido&#10;venda confirmada&#10;fechado"
              rows={6}
              value={form.data.sold_message_detection_keywords}
              onChange={(e) =>
                form.setData(
                  "sold_message_detection_keywords",
                  e.target.value,
                )
              }
            />
            <p className="text-muted-foreground text-xs">
              Insira uma palavra-chave por linha. A busca ignora maiúsculas e
              minúsculas.
            </p>
          </div>

          <div className="flex justify-end">
            <Button type="submit" disabled={form.processing}>
              {form.processing && (
                <Loader2 className="mr-2 size-4 animate-spin" />
              )}
              Salvar alterações
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
